export default {
  install(Vue) {

    Vue.prototype.goBack = function (e = -1) {
      window.history.length > 1 ? this.$router.go(e) : this.$router.push("/");
    };

    Vue.prototype.IEVersion = function () {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion === 7) {
          return 7;
        } else if (fIEVersion === 8) {
          return 8;
        } else if (fIEVersion === 9) {
          return 9;
        } else if (fIEVersion === 10) {
          return 10;
        } else {
          return 6; //IE版本<=7
        }
      } else if (isEdge) {
        return "Edge"; //edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1; //不是ie浏览器
      }
    };

    Vue.prototype.openURL = function (url = "") {
      let open = window.open("", "_blank")

      if (url.indexOf("http") === -1) {
        openURL = "http://" + url;
      }

      if (open === null || typeof (open) === "undefined") {
        window.location.href = url
        return
      }

      setTimeout(() => {
        open.location = url
      }, 300)
    };

    Vue.prototype.getMajorLayerName = function (layer) {
      if (layer == 1) {
        return "本科";
      } else if (layer == 2) {
        return "专科";
      } else if (layer == 3) {
        return "成考专升本";
      } else if (layer == 4) {
        return "成考高升专";
      } else if (layer == 5) {
        return "成考高升本";
      } else if (layer == 6) {
        return "专插本";
      }
    };

    Vue.prototype.getMainTypeName = function (type) {
      if (type == 1) {
        return "免费题库";
      } else if (type == 2) {
        return "历年真题";
      } else if (type == 3) {
        return "模拟试卷";
      } else if (type == 4) {
        return "VIP题库";
      } else if (type == 5) {
        return "章节训练";
      } else if (type == 6) {
        return "考前押密";
      }
    };

    Vue.prototype.getQuestionTypeName = function (type) {
      if (type == 1) {
        return "单选题"
      } else if (type == 2) {
        return "多选题"
      } else if (type == 3) {
        return "判断题"
      } else if (type == 4) {
        return "问答题"
      } else if (type == 5) {
        return "填空题"
      } else if (type == 6) {
        return "完形填空"
      } else if (type == 7) {
        return "阅读理解"
      } else if (type == 8) {
        return "名词解释"
      } else if (type == 100) {
        return "高频考点"
      }
    };

    //建立一個可存取到該file的url
    // jquery js 的代码：不同浏览器下的路径
    Vue.prototype.getObjectURL = function (file) {
      var url = null;

      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }

      return url;
    };

    Vue.prototype.getBiguoPlatformName = function (type) {
      if (type == "1") {
        return "Android";
      } else if (type == "2") {
        return "iOS";
      } else if (type == "3") {
        return "小程序";
      } else if (type == "4") {
        return "微信公众号";
      } else if (type == "5") {
        return "PC官网";
      }
    };

    Vue.prototype.getPayTypeName = function (type) {
      if (type == "0") {
        return "支付宝";
      } else if (type == "1") {
        return "微信";
      }
    }

    Vue.prototype.getColorWithIndex = function (index) {
      return ["#3C65A8", "#EC7F25", "#329F91", "#8957B2", "#92795C", "#23B2C8"][parseInt(index)]
    };

    Vue.prototype.formatDate = function (now) {
      var year = now.getFullYear();  //取得4位数的年份
      var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
      var date = now.getDate();      //返回日期月份中的天数（1到31）

      if (month < 10) {
        month = "0" + month
      }
      if (date < 10) {
        date = "0" + date
      }

      return year + "-" + month + "-" + date
    };

    Vue.prototype.formatTime = function (now) {
      var year = now.getFullYear();  //取得4位数的年份
      var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
      var date = now.getDate();      //返回日期月份中的天数（1到31）
      var hour = now.getHours();     //返回日期中的小时数（0到23）
      var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
      var second = now.getSeconds(); //返回日期中的秒数（0到59）

      if (month < 10) {
        month = "0" + month
      }
      if (date < 10) {
        date = "0" + date
      }
      if (hour < 10) {
        hour = "0" + hour
      }
      if (minute < 10) {
        minute = "0" + minute
      }
      if (second < 10) {
        second = "0" + second
      }

      return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    };

    Vue.prototype.joinHtml = function (body) {
      if (body.indexOf("<!DOCTYPE html>") == -1) {
        let html = "<!DOCTYPE html>\n\n" +

          "<html>\n\n" +
          "<head>\n" +
          "<meta charset=\"utf-8\">\n" +
          "<meta name=\"viewport\" content=\"initial - scale=1.0; maximum - scale=1.0; user - scalable=no\" />\n\n" +

          "<title>笔果自考题库考前押密用户购买服务协议</title>\n\n" +

          "<style type=\"text/css\">\n\n" +

          "body{font-size: 3.3vw;}\n\n" +

          "</style>\n\n" +

          "</head>\n\n" +

          "<body>\n\n" +

          body + "\n\n" +

          "</body>\n\n" +

          "</html>"

        return html
      } else {
        return body
      }
    };

    Vue.prototype.judgeBigScreen = function () {
      let result = false;

      const rate = window.screen.height / window.screen.width;
      let limit = window.screen.height == window.screen.availHeight ? 1.8 : 1.65; // 临界判断值  

      // window.screen.height为屏幕高度
      //  window.screen.availHeight 为浏览器 可用高度

      if (rate > limit) {
        result = true;
      }

      // console.log(result);

      return result;
    };

    // 笔果用户信息保存
    Vue.prototype.setBiguoUserInfo = function (json) {
      if (window.localStorage) {
        let storage = window.localStorage

        if (json) {
          storage.setItem('h5_biguo_user_info', JSON.stringify(json))
        } else {
          storage.removeItem('h5_biguo_user_info')
        }
      }
    };

    // 笔果用户信息获取
    Vue.prototype.getBiguoUserInfo = function () {
      if (window.localStorage) {
        let storage = window.localStorage
        let cache = storage.getItem('h5_biguo_user_info')

        if (cache) {
          return JSON.parse(cache)
        } else {
          return undefined
        }
      }
    };

    // 笔果用户信息删除
    Vue.prototype.removeBiguoUserInfo = function () {
      if (window.localStorage) {
        let storage = window.localStorage
        storage.removeItem('h5_biguo_user_info')
      }
    };

    Vue.prototype.formatPhone = function (phone) {
      if (phone && phone.length == 11) {
        // 133 77778 907
        let arr = phone.split('')
        arr.splice(3, 5, '*****')
        return arr.join('')
      }

      return phone
    };
  }
};



// WEBPACK FOOTER //
// ./src/base.js